import {
  loyaltyConfigurationSchema,
  loyaltyEarningRuleSchema,
} from "@redotech/redo-loyalty-common/loyalty-definition";
import * as z from "zod";

export const upsertLoyaltyConfiguration = {
  name: "upsertLoyaltyConfiguration" as const,
  input: z.object({
    enabled: z.boolean().optional(),
    pointValue: z
      .number()
      .positive()
      .describe("USD value per point (e.g., 0.01)")
      .optional(),
    expirationMonths: z
      .number()
      .int()
      .positive()
      .describe("Number of months after which points expire")
      .min(1)
      .max(24)
      .optional(),
    excludedShopifyCollectionIds: z.array(z.string()).optional(),
    earningRules: z.array(loyaltyEarningRuleSchema).optional(),
  }),
  output: loyaltyConfigurationSchema,
};
